import React from 'react';
import { featuredClients } from '../data/site';

const Industries = () => (
  <section className="industries" aria-label="Some of our clients">
    <div className="container industries-inner">
      <p className="industries-label">Trusted by institutes and organisations</p>
      <ul className="industries-list">
        {featuredClients.map((client) => (
          <li key={client}>{client}</li>
        ))}
      </ul>
    </div>
  </section>
);

export default Industries;
